import React from 'react';
import { useGetHomeFeatureQuery } from '../../redux/apis/endpoints/homeFeatureApi';
import { useGetProductsQuery } from '../../redux/apis/endpoints/productApi';
import './landing.css';
import HeroSection from './sections/HeroSection';
import FeaturedSection from './sections/FeaturedSection';
import HowItWorksSection from './sections/HowItWorksSection';
import TreasureHuntSection from './sections/TreasureHuntSection';
import SustainabilitySection from './sections/SustainabilitySection';
import CTASection from './sections/CTASection';

const LandingPage = () => {
  // Fetch the CMS-managed home feature content
  const { data: homeFeature, isLoading: homeLoading } = useGetHomeFeatureQuery();

  // Fallback: fetch most viewed products if home-feature has no featured listings
  const { data: fallbackListings, isLoading: fallbackLoading } = useGetProductsQuery({
    _sort: 'viewCount:DESC',
    _limit: 6,
    published_at_null: false,
  });

  // Hero images from CMS, or fall back to first 2 listings
  const heroImages = {
    main: homeFeature?.heroImage1?.url || null,
    accent: homeFeature?.heroImage2?.url || null,
  };

  // Hero listings from CMS relations (for clickable images with designer info)
  const heroListings = {
    main: homeFeature?.heroProduct1 || null,
    accent: homeFeature?.heroProduct2 || null,
  };

  // Featured listings from CMS relation, or fall back to newest
  const cmsListings = homeFeature?.featuredProducts;
  const hasCmsListings = cmsListings && cmsListings.length > 0;
  const featuredListings = hasCmsListings ? cmsListings : (fallbackListings || []);
  const isLoading = homeLoading || (!hasCmsListings && fallbackLoading);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-page">
      <HeroSection />
      <FeaturedSection listings={featuredListings} isLoading={isLoading} />
      <HowItWorksSection />
      {/* <TreasureHuntSection /> */}
      <SustainabilitySection />
      <CTASection />
    </div>
  );
};

export default LandingPage;
